import dealerProfitDetail from './dealer_profit_detail.vue';

export default dealerProfitDetail;
